import React from 'react'

export const ErrorIcon = () => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="7.99992" cy="8.00016" r="6.16667" stroke="#C4423B"/>
<path d="M12.6666 12.6668L3.33325 3.3335" stroke="#C4423B"/>
</svg>
